module.exports = __webpack_public_path__ + "img/mgg.c06db5bd.svg";